/**
 * HVAC Constants and Options
 */

// Supply duct sizes (inches)
export const SUPPLY_DUCT_SIZES = [
  { value: 4, label: '4"' },
  { value: 6, label: '6"' },
  { value: 8, label: '8"' },
  { value: 10, label: '10"' },
  { value: 12, label: '12"' },
  { value: 14, label: '14"' },
];

// Return duct sizes (inches) - larger
export const RETURN_DUCT_SIZES = [
  { value: 12, label: '12"' },
  { value: 14, label: '14"' },
  { value: 16, label: '16"' },
  { value: 18, label: '18"' },
  { value: 20, label: '20"' },
  { value: 24, label: '24"' },
];

// Duct types
export const DUCT_TYPES = {
  supply: {
    label: 'Supply',
    color: '#e65100', // Orange
    strokeColor: '#bf360c',
    defaultSize: 6,
    sizes: SUPPLY_DUCT_SIZES,
  },
  return: {
    label: 'Return',
    color: '#1565c0', // Blue
    strokeColor: '#0d47a1',
    defaultSize: 14,
    sizes: RETURN_DUCT_SIZES,
  },
};

// Duct shape types
export const DUCT_SHAPES = {
  trunk: {
    label: 'Trunk (Rectangular)',
    description: 'Main duct runs, typically sheet metal',
  },
  flex: {
    label: 'Flex (Round)',
    description: 'Flexible duct runs to registers',
  },
};

// Duct materials
export const DUCT_MATERIALS = [
  { value: 'sheet-metal', label: 'Sheet Metal' },
  { value: 'flex', label: 'Flex Duct' },
  { value: 'duct-board', label: 'Duct Board' },
  { value: 'fiberglass', label: 'Fiberglass' },
];

// Fitting types
export const FITTING_TYPES = {
  elbow90: {
    label: '90° Elbow',
    icon: '⌐',
    rotation: 0,
  },
  elbow45: {
    label: '45° Elbow',
    icon: '∠',
    rotation: 0,
  },
  tee: {
    label: 'Tee',
    icon: '⊥',
    rotation: 0,
  },
  wye: {
    label: 'Wye',
    icon: 'Y',
    rotation: 0,
  },
  reducer: {
    label: 'Reducer',
    icon: '><',
    rotation: 0,
  },
  endcap: {
    label: 'End Cap',
    icon: '|',
    rotation: 0,
  },
};

// HVAC equipment types
export const EQUIPMENT_TYPES = {
  furnace: {
    label: 'Furnace',
    width: 24,
    height: 30,
    color: '#795548',
  },
  airHandler: {
    label: 'Air Handler',
    width: 24,
    height: 48,
    color: '#607d8b',
  },
  condenser: {
    label: 'Condenser',
    width: 30,
    height: 30,
    color: '#78909c',
  },
  register: {
    label: 'Register/Grille',
    width: 12,
    height: 6,
    color: '#90a4ae',
  },
  returnGrille: {
    label: 'Return Grille',
    width: 20,
    height: 20,
    color: '#546e7a',
  },
};

// Default duct properties
export const DEFAULT_DUCT = {
  type: 'supply',
  ductShape: 'trunk',
  size: 6,
  material: 'sheet-metal',
  insulated: false,
};

// Duct drawing settings
export const DUCT_DRAW_SETTINGS = {
  snapDistance: 10, // pixels to snap to walls/ducts
  minLength: 12, // minimum duct length in inches
  labelFontSize: 10,
  strokeWidth: 2,
};
